import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { DialogService } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
  providers: [MessageService, DialogService],
})
export class ForgotPasswordComponent {
  forgotPasswordForm: FormGroup;
  errorMessage: string | null = null;
  isLoading$: Observable<boolean>;
  isSubmitting = false;
  hidePassword = true;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private dialogService: DialogService,
    private router: Router
  ) {
    this.isLoading$ = this.authService.isLoading$;
    console.log('URL actual:', window.location.href);
    console.log('URL original:', window.location.origin);

    this.forgotPasswordForm = this.fb.group({
      email: ['', Validators.required],
      url: [window.location.origin, Validators.required],
    });
  }

  onSubmit() {
    if (this.forgotPasswordForm.valid) {
      this.isSubmitting = true;
      const { email, url } = this.forgotPasswordForm.value;

      this.authService.forgotPassword(email, url).subscribe({
        next: (response) => {
          if (response) {
            setTimeout(() => {
              this.router.navigate(['/auth/login']);
            }, 1500);
          } else {
            this.isSubmitting = false;
          }
        },
        error: (error) => {
          this.errorMessage = error.error.message;
          this.isSubmitting = false;
        },
      });
    } else {
      this.errorMessage = 'Por favor, complete todos los campos.';
    }
  }

  goToLogin() {
    this.router.navigate(['/auth/login']);
  }
}
